/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import Tbl from '@appblocks/codegeneration/Libraries/Tbl';
import TableItem from '@appblocks/codegeneration/SettingsConfigurations/TableItem';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const project: ProjectConfiguration = feature.project;
    const GROUPS = feature.getSettingValue('GROUPS');
    const dashboardEnabled = feature.getEnabled();
    const appVersion = project.getSettingValue('general', 'FIRMWAREVERSION');
    const TABLES = feature.getSettingValue('TABLES');
    const appID = project.id;

    if (!feature.getEnabled()) {
        return blocks;
    }

    let variableGetCode = '';
    let variableSetCode = '';
    const variablesGetCode: string[] = [];
    let cmdExecCode = '';
    const widgets = feature.getSettingValue('WIDGETS');
    const widgetsArray = [];
    const variableInCode: { [variable: string]: boolean } = {};
    blocks.push({
        location: 'DASHBOARD_SETUP_TITLE',
        blockType: BlockType.LOCATION,
        template: `
    "title": "${feature.getSettingValue('DASHBOARD_TITLE')}"`,
    });
    if (widgets.length > 0 && dashboardEnabled) {
        for (let i = 0; i < widgets.length; i++) {
            const widget = widgets[i].getWidgetObject();
            let { variable, linkType } = widget;
            try {
                const item = project.getFeature(variable);
                if (item?.id === 'variable') {
                    variable = item.getSettingValue('VARNAME');
                    let varValue = project.convertDataType(variable, item.getSettingValue('DATATYPE'), TibboDataType.STRING, '');
                    if (item.getSettingValue('DATATYPE') === TibboDataType.STRING) {
                        varValue = `"\\x22"+${varValue}+"\\x22"`;
                    }
                    linkType = 'variable';
                    if (!Object.prototype.hasOwnProperty
                        .call(variableInCode, variable)) {
                        variableGetCode += `
            if query['variable'] == "${variable}":
                response = str(${varValue})`;
                        variableSetCode += `
        if query['variable'] == "${variable}":
            var_${variable}_set(${project.convertDataType('value', TibboDataType.STRING, item.getSettingValue('DATATYPE'))})`;
                        variableInCode[variable] = true;

                        variablesGetCode.push(`variables['${variable}'] = ${varValue}`);
                    }
                } else if (item?.id === 'command') {
                    variable = item.getSettingValue('NAME');
                    linkType = 'command';
                    if (!Object.prototype.hasOwnProperty
                        .call(variableInCode, variable)) {
                        cmdExecCode += `
        if query["variable"] == "${variable}":
            cmd_${variable}(query["value"])`;
                        variableInCode[variable] = true;
                    }
                }
                widget.variable = variable;
                widget.linkType = linkType;
                widgetsArray.push(widget);
            } catch (ex) {
                widgets.splice(i, 1);
                i--;
            }
        }
    }

    //         for (let i = 0; i < widgets.length; i++) {
    //             const widget = widgets[i];
    //             if (widget.settings.customFn !== '') {
    //                 blocks.push({
    //                     location: 'DASHBOARD_CUSTOM_FN_DEF',
    //                     blockType: BlockType.LOCATION,
    //                     template: `
    // function custom${widget.id} (data) {
    //     ${widget.settings.customFn}
    // }`,
    //                 });
    //             }
    //         }

    for (let i = 0; i < TABLES.length; i++) {
        const tblItem = project.getFeature(TABLES[i].getSettingValue('TABLE')) as TableItem;
        if (!tblItem) {
            continue;
        }
        const tableJson = Tbl.getTableJson(tblItem);
        blocks.push({
            location: 'WEB_CONSOLE_TABLES',
            blockType: BlockType.CODE,
            template: `
            ${JSON.stringify(tableJson)},`,
        });
    }

    blocks.push({
        location: 'DASHBOARD_SETUP_WIDGETS',
        blockType: BlockType.CODE,
        template: `
        "updateInterval": ${feature.getSettingValue('INTERVAL') * 1000},
        "widgets": ${JSON.stringify(widgetsArray)},
        "widgetColumns": ${feature.getSettingValue('WEB_ADMIN_WIDGET_COLUMNS')},`,
    });

    blocks.push({
        location: 'DASHBOARD_APP_VERSION',
        blockType: BlockType.CODE,
        template: `
        "appName": "${project.name}",
        "appVersion": "${appVersion}",
        "appId": "${appID}",
        `,
    });

    blocks.push({
        location: 'HTTP_CMD_TRIGGER',
        blockType: BlockType.CODE,
        template: `
    ${cmdExecCode}
`,
    });

    const settingGroups = feature.getSettingValue('GROUPS');

    for (let i = 0; i < settingGroups.length; i += 1) {
        const group = settingGroups[i];
        const settings = group.getSettingValue('SETTINGS');
        for (let j = 0; j < settings.length; j += 1) {
            const setting = settings[j];
            const settingItem = project.getFeature(setting.getSettingValue('SETTINGID'));
            if (!settingItem) {
                continue;
            }
            const variable = settingItem.getSettingValue('SETTINGID');
            const varValue = project.convertDataType(variable, settingItem.getSettingValue('DATATYPE'), TibboDataType.STRING);
            if (!Object.prototype.hasOwnProperty
                .call(variableInCode, variable)) {
                variableGetCode += `
            if query['variable'] == "${variable}":
                response=json.dumps(${varValue})`;
                variableSetCode += `
        if query['variable'] == "${variable}":
            var_${variable}_set(${project.convertDataType('value', TibboDataType.STRING, settingItem.getSettingValue('DATATYPE'))})`;
                variableInCode[variable] = true;
                variablesGetCode.push(`variables['${variable}'] = ${varValue}`);
            }
        }
    }

    // password
    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `http_server_password = ${feature.getSettingValue('PASSWORD')}`,
    });

    // front end widgets template
    if (!process.env.BROWSER) {
        // eslint-disable-next-line global-require
        const fs = require('fs');
        // eslint-disable-next-line global-require
        const path = require('path');
        let pathRoot = (globalThis as any).appRoot;
        if (pathRoot === undefined) {
            pathRoot = path.join(__dirname, '..', '..', 'frontend');
        } else {
            pathRoot = path.join(pathRoot, 'frontend');
        }
        const widgetCss = fs.readFileSync(path.join(pathRoot, 'src/client/Components/DeviceDashboard/widgets.css'), 'utf8');
        const marker = '/* FRONTEND_START_MARKER */';

        blocks.push({
            location: 'DASHBOARD_STYLE',
            blockType: BlockType.CODE,
            template: `
        <style>
            ${widgetCss}
        </style>`,
        });
    }

    let settingsCode = '';
    for (let i = 0; i < GROUPS.length; i++) {
        const tmpBlocks = GROUPS[i].getCodeBlocks();
        for (let j = 0; j < tmpBlocks.length; j++) {
            if (tmpBlocks[j].location === 'LUIS_GROUP_ITEM') {
                settingsCode += tmpBlocks[j].template;
                if (i + 1 < GROUPS.length) {
                    settingsCode += ',';
                }
            }
        }
    }

    blocks.push({
        location: 'DASHBOARD_SETUP_STATE',
        blockType: BlockType.LOCATION,
        template: `
    "firmwareUploadEnabled": false,`,
    });

    blocks.push({
        location: 'DASHBOARD_SETTINGS_SCHEMA',
        template: settingsCode,
    });

    blocks.push({
        location: 'IMPORTS',
        id: 'import json',
        template: `
import json`,
    });

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        template: `
@webserver.route('/console_Main.js')
async def handler(r, w):
    await http_send_file(w, 'console_Main.js.gz')

@webserver.route('/console_Dashboard.js')
async def handler(r, w):
    await http_send_file(w, 'console_Dashboard.js.gz')

@webserver.route('/dashboard_setup.json')
async def handler(r, w):
    await http_send_file(w, 'dashboard_setup.json')

@webserver.route('/api.html', methods=['GET'])
async def handler(r, w):
    items = r.query.split('&')
    response=''
    query = {}
    for item in items:
        key, value = item.split('=')
        query[key] = value
                
    if query['e'] == 'i':
        response=json.dumps({
            "firmwareVersion":"pico",
            "ip":wlan.ifconfig()[0],
            "mac":binascii.hexlify(wlan.config('mac')),
            "wlnmac": binascii.hexlify(wlan.config('mac')),
            "wlnip":wlan.ifconfig()[0],
            "bootTime":"1711685641",
            "wifiOn":"0",
            "timezone":str(APP_TIMEZONE),
            "time":"1711968191"
        })
    elif query['e'] == 'v':
        if query['action'] == 'get':
            ${variableGetCode}
            pass
    elif query['e'] == 'w':
        variables = {}
        ${variablesGetCode.map(item => `
        ${item}`).join('')}
        response=json.dumps(variables)

    w.write(b'HTTP/1.0 200 OK\\r\\n')
    w.write(f'Content-Type: text/plain\\r\\n')
    w.write(f'Access-Control-Allow-Origin: *\\r\\n')
    w.write(b'\\r\\n')
    w.write(response)
    # write page body
    await w.drain()

@webserver.route('/api.html', methods=['POST'])
async def handler(r, w):
    body = await r.read(1024)
    data=unquote(body).decode('utf-8')
    response='0'
    query = {}
    if data.index('&') >= 0:
        items = data.split('&')
        
        for item in items:
            key, value = item.split('=')
            query[key] = value
    if query['e'] == 'v' and query['action'] == 'set':
        ${variableSetCode}
        pass

    if query['e'] == 's' and query['a'] == 'cmd':
        if query['cmd'] == 'E':
            machine.reset()
        if query['cmd'] == 'I':
            stg_restore_multiple()
    if query['e'] == 'f' and query['action'] == 'f_set':
        #****HTTP_CMD_TRIGGER****#
        pass
        
        
        
    w.write(b'HTTP/1.0 200 OK\\r\\n')
    w.write(f'Content-Type: text/plain\\r\\n')
    w.write(f'Access-Control-Allow-Origin: *\\r\\n')
    w.write(b'\\r\\n')
    w.write(response)
    # write page body
    await w.drain()
`,
    });

    return blocks;
};
